export default "__VITE_ASSET__9e49774e__"